import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface InboxGetMessagesParams {
  page?: number;
  perPage?: number;
  unseen?: boolean;
  folder?: 'inbox' | 'sent';
  search?: string;
  searchBody?: boolean;
  refresh?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class InboxService {
  private apiUrl = environment.apiURL + 'inbox/messages';

  constructor(private http: HttpClient) {}

  getMessages(opts: InboxGetMessagesParams = {}): Observable<any> {
    let params = new HttpParams()
      .set('page', (opts.page || 1).toString())
      .set('per_page', (opts.perPage || 20).toString());
    if (opts.unseen) {
      params = params.set('unseen', '1');
    }
    if (opts.folder && opts.folder !== 'inbox') {
      params = params.set('folder', opts.folder);
    }
    if (opts.search && opts.search.trim().length >= 2) {
      params = params.set('search', opts.search.trim());
      if (opts.searchBody) {
        params = params.set('search_body', '1');
      }
    }
    if (opts.refresh) {
      params = params.set('refresh', '1');
    }
    return this.http.get(this.apiUrl, { params });
  }

  getMessage(uid: number, folder: string = 'inbox'): Observable<any> {
    let params = new HttpParams();
    if (folder !== 'inbox') {
      params = params.set('folder', folder);
    }
    return this.http.get(`${this.apiUrl}/${uid}`, { params });
  }

  getThread(uid: number, folder: string = 'inbox', withBody: boolean = true, refresh: boolean = false): Observable<any> {
    let params = new HttpParams();
    if (folder !== 'inbox') {
      params = params.set('folder', folder);
    }
    if (withBody) {
      params = params.set('with_body', '1');
    }
    if (refresh) {
      params = params.set('refresh', '1');
    }
    return this.http.get(`${this.apiUrl}/${uid}/thread`, { params });
  }

  downloadAttachment(uid: number, index: number, folder: string = 'inbox'): Observable<Blob> {
    let params = new HttpParams();
    if (folder !== 'inbox') {
      params = params.set('folder', folder);
    }
    return this.http.get(`${this.apiUrl}/${uid}/attachments/${index}`, {
      responseType: 'blob',
      params,
    });
  }

  reply(uid: number, bodyHtml: string, attachments?: File[]): Observable<any> {
    if (attachments && attachments.length > 0) {
      const formData = new FormData();
      formData.append('body_html', bodyHtml);
      attachments.forEach(file => formData.append('attachments[]', file));
      return this.http.post(`${this.apiUrl}/${uid}/reply`, formData);
    }
    return this.http.post(`${this.apiUrl}/${uid}/reply`, { body_html: bodyHtml });
  }
}
